<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <!-- <v-container>
            <v-row>
                <v-col cols="12">
                    <v-text-field label="ค้นหาเมนูอาหาร" v-model="search" @keyup="searchMenu()" :color="border_color" outlined></v-text-field>
                </v-col>
            </v-row>
        </v-container> -->
        <div>
            <div v-for="(drink_detail,key) in drink_list" :key="key">
                <v-card class="mb-5 pa-3" v-if="drink_detail.status == 1">
                    <div class="cursor_type_drink" @click="openDetail(drink_detail.id)">
                        <div class="d-flex justify-space-between">
                            <div class="d-flex flex-column justify-space-between size_title_type_drink">
                                <div>
                                    <div>{{ drink_detail.name }} <span class="description_type_drink">( {{ drink_detail.nameEng }} )</span></div>
                                    <div class="description_type_drink">
                                        {{ drink_detail.sub_title }}
                                    </div>
                                </div>

                                <div>{{ Intl.NumberFormat().format(drink_detail.price) }} ฿</div>
                            </div>
                            <div class="img_type_drink">
                                <img :src="drink_detail.path" v-if="drink_detail.path">
                                <img :src="food_image" v-if="!drink_detail.path">
                            </div>
                        </div>
                    </div>
                </v-card>
                <v-card class="mb-5 pa-3" style="background:#eee" v-if="drink_detail.status == 0">
                    <div class="cursor_type_drink">
                        <div class="d-flex justify-space-between">
                            <div class="d-flex flex-column justify-space-between size_title_type_drink">
                                <div>
                                    <h4 class="itemout_type_drink">ขออภัยสินค้าหมด</h4>
                                    <div>{{ drink_detail.name }} <span class="description_type_drink">( {{ drink_detail.nameEng }} )</span></div>
                                    <div class="description_type_drink">
                                        {{ drink_detail.sub_title }}
                                    </div>
                                </div>

                                <div>{{ Intl.NumberFormat().format(drink_detail.price) }} ฿</div>
                            </div>
                            <div class="img_type_drink">
                                <img :src="drink_detail.path" v-if="drink_detail.path">
                                <img :src="food_image" v-if="!drink_detail.path">
                                <div class="img_sole_type_drink">
                                    <img src="@/assets/soulout.png">
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
    <AddToppingMenu />
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/fast-food.png";
import AddToppingMenu from '@/components/menuuser/addmenu/AddToppingMenu.vue'
export default {
    components: {
        AddToppingMenu
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            border_color: '#038cc1',
            food_image: before_image,
            search: '',
            drink_search_default_list: [],
            drink_list: [],
        }
    },
    methods: {
        async searchMenu(){
            this.drink_list = this.drink_search_default_list.filter(detail => detail.name.toLowerCase().indexOf(this.search) > -1);
        },
        async drinkList() {
            if (this.$route.name == 'buffetUser' || this.$route.name == 'singleDishMealUser') {
                HTTP.get('/customer/drink-menu-list', {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.drink_search_default_list = response.data.listDrink
                            this.drink_list = response.data.listDrink
                            this.loading_page = false
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (this.$route.name == 'takeOutUser' || this.$route.name == 'takeOutUserTable' || this.$route.name == 'orderOnlinePickUp') {
                HTTP.get('/customer/drink-menu-buyback-list', {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.drink_search_default_list = response.data.listDrink
                            this.drink_list = response.data.listDrink
                            this.loading_page = false
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async openDetail(id) {
            const dataList = {
                id: id,
                type: null
            }
            this.$root.$emit('getDetail', dataList)
        }
    },
    created(){
        HTTP.get('/showColor')
            .then((response) => {
                if (response.data.successful === true) {
                    this.border_color = response.data.color_code
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
                if (error.response.status === 500) {
                    this.$router.push('/nametakeoutuser')
                }
        })
    },
    mounted() {
        this.drinkList()
    }
}
</script>

<style scoped>
.cursor_type_drink {
    cursor: pointer;
}

.size_title_type_drink {
    font-size: 18px;
    width: 50%;
}

.description_type_drink {
    font-size: 14px;
    color: #696969;
}

.img_type_drink {
    position: relative;
    width: 150px;
}

.img_type_drink>img {
    max-width: 100%;
}

.itemout_type_drink {
    color: red;
}

.img_sole_type_drink {
    width: 85px;
    position: absolute;
    top: 0;
}

.img_sole_type_drink>img {
    max-width: 100%;
}
</style>
